import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
} from "@mui/material";
import styles from "./Product.module.css";

const ManageProduct = () => {
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  const handleNavigate = (path) => {
    window.location.href = path;
  };

  const navigateToProductDetails = (id) => {
    handleNavigate(`product-details/${id}`);
  };

  const handleButtonClick = (action) => {
    if (action === "Add Product") {
      handleNavigate("add-product");
    } else {
      alert(`${action} button clicked!`);
    }
  };

  const handleDeleteProduct = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this product?"
    );

    if (confirmDelete) {
      try {
        const response = await fetch(
          `https://cms-test.my-ogawa.com/backend/script/bodyfriend/product/delete_product.php?id=${id}`,
          {
            method: "DELETE",
          }
        );

        if (response.ok) {
          alert("Product deleted successfully");
          // Refresh the product list
          fetchProducts(currentPage, limit);
        } else {
          alert("Error deleting product");
        }
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    }
  };

  const fetchProducts = async (page, limit) => {
    try {
      const response = await fetch(
        `https://cms-test.my-ogawa.com/backend/script/bodyfriend/product/get_all_products.php?page=${page}&limit=${limit}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      setProducts(data.products);
      setTotalPages(Math.ceil(data.total / limit));
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage, limit);
  }, [currentPage, limit]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setCurrentPage(1); // Reset to first page when changing rows per page
  };

  return (
    <div>
      <h1>Manage Products</h1>

      <div className={styles.wrapButton}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleButtonClick("Add Product")}
        >
          Add Product
        </Button>
      </div>

      <div>
        <div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="product table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Product ID</TableCell>
                  <TableCell align="center">Category</TableCell>
                  <TableCell align="center">Product Name</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((product) => (
                  <TableRow
                    key={product.id}
                    hover
                    onClick={() => navigateToProductDetails(product.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell align="center">{product.id}</TableCell>
                    <TableCell align="center">{product.category}</TableCell>
                    <TableCell align="center">{product.name}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleDeleteProduct(product.id)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={totalPages * limit}
            rowsPerPage={limit}
            page={currentPage - 1}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ManageProduct;
